import script from "./BuySellBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./BuySellBtn.vue?vue&type=script&setup=true&lang=js"

import "./BuySellBtn.vue?vue&type=style&index=0&id=0154fd73&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0154fd73"]])

export default __exports__